import {useEffect, useState} from "react";
import {useInventory} from "../../context/InventoryContext";
import useToggle from "../../shared/functions/useToggle";

import {Avatar, Stack, Typography, Chip} from "@mui/material";

import AntDataGrid from "../../shared/components/AntDataGrid";
// import AntDataGridDeux from "../../shared/components/AntDataGridDeux";
import InventoryDataGridToolbar from "./InventoryDataGridToolbar";
import InventoryOrdered from "./InventoryOrdered";
import InventoryForcasted from "./InventoryForcasted";
import InventoryDetails from "./InventoryDetails";
// import AddQuantity from '../orders/fragments/AddQuantity';
import NewQtyForMonth from './NewQtyForMonth';
// import ProductStatus from "./ProductStatus";

const columns = [
    {
        title: 'Image', dataIndex: 'ImageUrl', key: 'ProductImageUrl',
        render: (image) => {
            return (
                <>
                    {
                        image
                            ? <Avatar alt={'...'} src={image}/>
                            : <Avatar>no</Avatar>
                    }
                </>
            )
        }
    },

    {
        title: 'Name', dataIndex: 'Name', key: 'Name',
        render: (val, {IsParent, HasChilds}) => {

            const ft = text => (text || '')?.trim()?.toLowerCase()

            const list = ['pack', ' pac ', ' pak ', ' pk '];

            let flag = ((IsParent || [])?.length > 0) || (HasChilds) || false

            list.forEach(label => {
                if (ft(val)?.includes(label))
                    flag = true
            })

            return (
                <Stack direction={'row'} spacing={1}>
                    <Typography>
                        {val}
                    </Typography>

                    {flag && (<Chip color={'success'} label={'Pk'}/>)}

                </Stack>
            )
        }
    },

    // {
    //     title: 'Seuil', dataIndex: 'Threshold', key: 'Threshold',
    //     render: (Threshold) => {
    //         return Threshold || 0
    //     }
    // }, <AddQuantity show={isCreateModalQuantityOpen}  itemData={selectedItem} onClose={handleCreateQuantityModalClosing}/>

    {
        title: 'Qt. by month', dataIndex: '_', key: 'Stock',
        render: (_, record) => (
            <NewQtyForMonth {...record}/>

        )
    },

/*
    {
        title: 'Month Qt.', dataIndex: '_', key: 'Stock',
        render: (_, {QuatityForMonth}) => QuatityForMonth ?? 0
    },*/

    // {
    //     title: 'Qt. available', dataIndex: '_', key: 'Stock',
    //     render: (_, record) => (
    //         <InventoryForcasted {...record} />
    //     )
    // },

    // {
    //     title: 'Qt. forcasted', dataIndex: '_', key: 'Stock',
    //     render: (_, record) => (
    //         <InventoryOrdered {...record} />
    //     )
    // },

    // {
    //     title: 'Qt. to purchase', dataIndex: '_', key: 'Stock',
    //     render: (_, {QuantityToBuy}) => QuantityToBuy
    // },

    // {
    //     title: 'Product Status', dataIndex: 'NotImportantToPurchase', key: 'Stock',
    //     render: (_, record) => (
    //         <ProductStatus {...record}  />
    //     )
    //     render: (NotImportantToPurchase, record) => (
    //         <span>
    //           {NotImportantToPurchase.map(NotImportantToPurchase => {
    //             let color = NotImportantToPurchase.length > 4 ? 'geekblue' : 'green';
    //             if (NotImportantToPurchase === 'false') {
    //               color = 'red';
    //             }
    //             return (
    //                 <ProductStatus {...record} />
    //             );
    //           })}
    //         </span>
    //       ),
    // },

];


export default function InventoryDataGrid() {
    const {data, loading, loadMore} = useInventory();
    const {open, handleOpen, handleClose} = useToggle()
    const [selected, setSelected] = useState(); 
    // console.log(data[0])

    const handleSelection = record => {
        //console.log("kkKK"+JSON.stringify(record))
        setSelected(record)
        handleOpen();
    }
    const handleOneSelection = record => {
        //console.log("kkKK"+JSON.stringify(record))
        setSelected(record)
        handleOpen();
    }

    const handleDetailModalClosing = () => {
        setSelected(null)
        handleClose()
    }

    const handlePageChange = (current, total) => (current === (total - 1) || current === total) && loadMore()
    return (
        <>
        
        <AntDataGrid 
                data={data}
                columns={columns} 
                isLoading={loading} 
                ToolBar={InventoryDataGridToolbar} 
                onPageChange={handlePageChange} 
                doubleClickAction={handleSelection} 
                shadows 
            />
           

            {
                selected && (
                    <InventoryDetails 
                        open={open} 
                        item={selected} 
                        onClose={handleDetailModalClosing} 
                    />
                )
            } 
        </>
    )

}